import React, { useState, useEffect, useCallback } from "react";
import { Container, Pagination, Col, Row } from 'react-bootstrap';
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { fetchAllUpcomingEvents } from "../Services/EventService";
import NewsCard from "../Components/NewsCard";
import Loader from "../Components/Loader";
import { getNews } from '../Services/NewsService';
import usePagination from '../hooks/usePagination';
import '../assets/style.css'
import { Helmet } from "react-helmet-async";
import { format } from 'date-fns';

const NewsScreen = () => {
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const {
        currentPage,
        totalPages,
        data: news,
        loading,
        handlePageChange,
        fetchPageData,
    } = usePagination(getNews);

    useEffect(() => {
        if (news.length === 0 && upcomingEvents.length === 0) {
            fetchPageData();
            getUpcomingEvents();
        }
    }, [news, upcomingEvents]);

    const getUpcomingEvents = useCallback(async () => {
        try {
            await fetchAllUpcomingEvents(setUpcomingEvents);
        } catch (error) {
            console.error("Failed to fetch upcoming events:", error);
        }
    }, [fetchAllUpcomingEvents, setUpcomingEvents]);

    return <>
        <Helmet>
            <title>News & Updates</title>
            <meta name="description" content=" Oasis Educational Institute" />
        </Helmet>
        <Breadcrumbs page="News & Events" label="Home" path="/" />
        <Row>
            <Container style={{ marginTop: '1%', marginBottom: '2%' }}>

                <Row className="d-flex justify-content-between">
                    {loading ? (
                        <Container className="d-flex justify-content-center align-items-center p-5  bg-opacity-50 backdrop-blur-sm">
                            <Loader />
                        </Container>
                    ) : news.length === 0 ? (
                        <h1 className="text-center m-20 text-4xl">No News is announced yet</h1>
                    ) : (
                        <Col lg={8}>
                            <div className="grid grid-cols-2 gap-1 me-4 pe-4">
                                {news.map((item, index) => (
                                    <NewsCard
                                        key={index}
                                        id={item.id}
                                        picture={item.file_id}
                                        name={item.uploaded_by}
                                        date={item.event_date}
                                        title={item.title}
                                    />
                                ))}
                            </div>
                        </Col>
                    )}

                    {!loading &&
                        (<Col lg={4} className="p-4 ms-auto">
                            <div className="d-flex justify-content-end">
                                <div className="p-4">
                                    <h1 className="text-end text-green-600 text-xl font-bold not-italic ms-2 pb-2">Upcoming Events</h1>
                                    <ol className="text-sm p-2 text-end">
                                        {upcomingEvents.length === 0 ?
                                            <li> <strong> No Upcoming events</strong></li>
                                            : upcomingEvents.map((event) => (<>
                                                <li><strong>"{event.event_name}"</strong> -  {event.date ? format(event.date, 'MMMM dd, yyyy') : 'Date not available'}</li>
                                            </>))
                                        }
                                    </ol>
                                </div>

                            </div>


                        </Col>)}
                </Row>

                {news.length !== 0 && (
                    <Row className="d-flex justify-content-center">
                        <Col lg={8} xl={8}>
                            <Pagination>
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                                    <Pagination.Item
                                        key={pageNumber}
                                        active={pageNumber === currentPage}
                                        onClick={() => handlePageChange(pageNumber)}
                                    >
                                        {pageNumber}
                                    </Pagination.Item>
                                ))}
                            </Pagination>
                        </Col>
                    </Row>
                )}
            </Container>
        </Row>


    </>;
};

export default NewsScreen;
